import { useContext, useEffect, useMemo, useState } from 'react';
import {
  CardHeader,
  Row,
  Col,
  Card,
  CardBody,
  Table,
  Button,
  Input,
  Badge,
} from 'reactstrap';

import api from 'services/api';
import { PropostaMaterialAvulso as IPropostaMaterialAvulso } from 'models/PropostaMaterialAvulso';
import { PropostaVersao } from 'models/PropostaVersao';
import Produto from 'models/Produto';
import AtividadeModel from 'models/ConfiguradorAtividade';
import PropostaVersaoProduto from 'models/PropostaVersaoProduto';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

import AutocompleteItemDomsge from 'components/AutocompleteItemDomsge';
import { FaPlusCircle } from 'react-icons/fa';
import ItemDomsge from 'models/ItemDomsge';
import { Checkbox, CircularProgress, makeStyles } from '@material-ui/core';
import toast from 'react-hot-toast';
import { PropostaContext } from 'views/pages/Proposta';
import { useQuery } from 'react-query';
import ValidarAcessoPrograma from 'models/ValidarAcessoPrograma';
import { useHistory } from 'react-router-dom';
import mensagemAtingirMeta from 'utils/mensagemAtingirMeta';
import AutocompleteItem, {
  iAutoCompleteItem,
} from 'components/AutocompleteItem';
import traduzirProdutoAtividade from 'utils/traduzirProdutoAtividade';
import ProdutoAtividade from 'models/ProdutoAtividade';
import formatCurrency from 'utils/formatCurrency';
import { Th, Td } from './styles';
import MaterialItem from '../MaterialItem';
import MaterialTotalItem from '../MaterialTotalItem';
import { MateriaisContext, PropostaMateriaisSelecao } from '../..';

// Para desabilitar temporariamente as ações
const OCULTAR_ACOES = true;

const MySwal = withReactContent(Swal);
export default function PropostaMaterialAvulso({
  isFaturamentoDireto,
  campoBusca,
  setPropostaMaterialSelecionado,
  propostaMaterialSelecionado,
  mostrarSelecao,
}: {
  isFaturamentoDireto: boolean;
  campoBusca: string;
  setPropostaMaterialSelecionado: React.Dispatch<
    React.SetStateAction<PropostaMateriaisSelecao[]>
  >;
  propostaMaterialSelecionado: PropostaMateriaisSelecao[];
  mostrarSelecao: boolean;
}): JSX.Element {
  const { propostaVersao, permiteModificacao, carregaPropostaVersao } =
    useContext(PropostaContext);
  const {
    setValorItens,
    setValorFrete,
    setValorFinal,
    setValorFinalDolar,
    setValorPercentualFrete,
    setValorDesconto,
    setValorServico,
  } = useContext(MateriaisContext);
  const [materiaisAvulsos, setMateriaisAvulsos] = useState<
    IPropostaMaterialAvulso[]
  >([]);
  const [loading, setLoading] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [itemDomsgeSelecionado, setItemDomsgeSelecionado] =
    useState<iAutoCompleteItem | null>(null);
  const [quantidadeNovoItem, setQuantidadeNovoItem] = useState(1);
  const [atividadeNovoItem, setAtividadeNovoItem] = useState<number>();
  const [atividades, setAtividades] = useState<ProdutoAtividade[]>([]);
  const [codEmpresa, setCodEmpresa] = useState('');
  const [produtoProposta, setProdutoProposta] = useState(0);
  const [acessoLimitadoListaMateriais, setAcessoLimitadoListaMateriais] =
    useState(true);
  const [acessoIncluiMaterialAvulso, setacessoIncluiMaterialAvulso] =
    useState(false);
  const history = useHistory();

  async function getAcessoLimitadoPrograma() {
    const response = await api.get('/acesso-programa/acesso-limitado', {
      params: {
        programaId: 60,
      },
    });
    setAcessoLimitadoListaMateriais(response.data);
  }

  async function getAcesssoIncluiMaterialAvulso() {
    const response = await api.get('/acesso-programa/acesso-programa', {
      params: {
        programaId: 118,
      },
    });
    setacessoIncluiMaterialAvulso(response.data.temAcesso);
  }

  async function returnMateriaisMarcadosPropVerAnterior() {
    const response = await api.get(
      `/proposta/versao/${propostaVersao.id}/material`,
    );

    const registrosResp = response.data;

    const materialAvulsoFatDiretoOriginal: PropostaMateriaisSelecao[] =
      registrosResp
        .filter((item: any) => item.selecionadoFatDireto === true)
        .map((item: any) => {
          return {
            desconto: item.desconto,
            id: item.id,
            isAvulso: true,
            isFaturamentoDireto: item.selecionadoFatDireto,
          };
        });

    setPropostaMaterialSelecionado(prev => [
      ...prev,
      ...materialAvulsoFatDiretoOriginal,
    ]);
  }

  useEffect(() => {
    getAcessoLimitadoPrograma();
    getAcesssoIncluiMaterialAvulso();
    returnMateriaisMarcadosPropVerAnterior();
  }, []);

  const valorTotalAvulsos = materiaisAvulsos.reduce(
    (total, item) => total + Number(item.valorTotal || 0),
    0,
  );

  async function returnMateriais(): Promise<IPropostaMaterialAvulso[]> {
    const response = await api.get(
      `/proposta/versao/${propostaVersao.id}/material`,
    );

    return response.data;
  }

  const { data: dataMateriaisAvulsos, isLoading } = useQuery(
    ['proposta-configuracao-materiais-avulsos', propostaVersao.id],
    async () => {
      const data = await returnMateriais();
      return data;
    },
  );

  useEffect(() => {
    if (dataMateriaisAvulsos) {
      setMateriaisAvulsos(dataMateriaisAvulsos);
    }
  }, [dataMateriaisAvulsos]);

  useEffect(() => {
    async function fetchMateriais() {
      const val = await returnMateriais();
      setMateriaisAvulsos(val);
    }

    fetchMateriais();
  }, [propostaMaterialSelecionado]);

  useEffect(() => {
    setLoading(isLoading);
  }, [isLoading]);

  async function carregaMateriaisAvulsos(): Promise<void> {
    try {
      setLoading(true);
      const data = await returnMateriais();
      setMateriaisAvulsos(data);
    } finally {
      setLoading(false);
    }
  }

  async function carregaPropostaV() {
    const response = await api.get(`/proposta/versao/${propostaVersao.id}`);
    const propostaVersaoData = response.data as PropostaVersao;
    // cabeçalho
    setValorItens(propostaVersaoData.valorItens);
    setValorFrete(Number(propostaVersaoData.percentualFrete));
    setValorFinal(propostaVersaoData.valorFinal);
    setValorFinalDolar(propostaVersaoData.valorFinalDolar);
    // rodapé
    setValorPercentualFrete(propostaVersaoData.percentualFrete);
    setValorDesconto(propostaVersaoData.valorDesconto);
    setValorServico(propostaVersaoData.valorServico);
  }

  function handleOnAddFinanciamentoDiretoAvulsos(
    materialAvulso: IPropostaMaterialAvulso,
  ) {
    setPropostaMaterialSelecionado(prev => {
      const existe = prev.find(item => item.id === materialAvulso.id);

      if (existe) {
        return prev.filter(item => item.id !== materialAvulso.id);
      }
      return [
        ...prev,
        {
          id: materialAvulso.id,
          desconto: materialAvulso?.desconto ?? 0,
          isAvulso: true,
          isFaturamentoDireto,
          codigo:
            materialAvulso.material.codigoSap ??
            materialAvulso.material.diteCodigo,
          fabricanteDesc: materialAvulso.material.descricaoFabrSge,
        },
      ];
    });
  }

  async function addMaterialAvulso() {
    if (!itemDomsgeSelecionado) {
      return;
    }
    try {
      setUpdating(true);
      await mensagemAtingirMeta(
        `Foi adicionado um material avulso na proposta`,
        Number(propostaVersao.id),
      );

      await api.post(`/proposta/versao/${propostaVersao.id}/material`, {
        materialId: itemDomsgeSelecionado.id,
        quantidade: quantidadeNovoItem,
        atividade: atividadeNovoItem,
      });
      setItemDomsgeSelecionado(null);
      setAtividadeNovoItem(0);
      setQuantidadeNovoItem(1);

      carregaMateriaisAvulsos();
      carregaPropostaV();
      carregaPropostaVersao();
    } finally {
      setUpdating(false);
    }
  }

  async function updateMaterialAvulso(materialAvulso: IPropostaMaterialAvulso) {
    try {
      setUpdating(true);
      const { id, quantidade, atividade } = materialAvulso;
      await api.put(`/proposta/versao/${propostaVersao.id}/material/${id}`, {
        quantidade: Number(quantidade),
        atividade: atividade || '',
      });
      carregaMateriaisAvulsos();
      carregaPropostaV();
      carregaPropostaVersao();
    } finally {
      setUpdating(false);
    }
  }

  async function deleteMaterialAvulso(materialAvulsoId: number) {
    let motivo = '';

    async function deletePropostaConfiguracaoMaterial() {
      try {
        await mensagemAtingirMeta(
          `Foi removido um material avulso na proposta`,
          Number(propostaVersao.id),
        );
        setUpdating(true);
        await api.delete(
          `/proposta/versao/${propostaVersao.id}/material/${materialAvulsoId}?motivo=${motivo}`,
        );
        const novoMateriaisAvulsos = materiaisAvulsos.filter(
          materialAvulso => materialAvulso.id !== materialAvulsoId,
        );
        setMateriaisAvulsos(novoMateriaisAvulsos);
      } finally {
        setUpdating(false);
      }
    }

    async function openModal() {
      MySwal.fire({
        title: `Deseja excluir o material avulso?`,
        html: `<br />
        <strong>Informe um motivo da exclusão do material:</strong>
        <input id="swal-input1" value='${motivo}' class="swal2-input">`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: `Sim, excluir`,
        confirmButtonColor: '#d33',
        cancelButtonText: `Não`,
      }).then(result => {
        const input = Swal?.getHtmlContainer()?.querySelector(
          '#swal-input1',
        ) as any;

        motivo = input.value;
        if (result.isConfirmed) {
          if (motivo.length < 5) openModal();
          else deletePropostaConfiguracaoMaterial();
        }
      });
    }

    openModal();
  }

  async function listaAtividades() {
    const response = await api.get('/produto-atividade');
    setAtividades(response.data);
  }

  async function buscarCodigoEmpresaProposta() {
    const response = await api.get(
      `/proposta/versao/${propostaVersao.id}/empresa-proposta`,
    );
    setCodEmpresa(response.data);
  }

  async function buscarProdutoProposta() {
    const response = await api.get(
      `/proposta/versao/${propostaVersao.id}/produto-proposta`,
    );
    setProdutoProposta(Number(response.data));
  }

  useEffect(() => {
    if (propostaVersao.id) {
      listaAtividades();
      buscarProdutoProposta();
      buscarCodigoEmpresaProposta();
    }
  }, [propostaVersao]);

  useEffect(() => {
    if (updating) {
      toast.loading('Aguarde...', { position: 'top-right' });
      return;
    }

    toast.dismiss();
  }, [updating]);

  function handleChangeValue(id: number, name: string, value: number | string) {
    const novoMateriaisAvulsos = materiaisAvulsos.map(materialAvulso =>
      materialAvulso.id === id
        ? {
            ...materialAvulso,
            [name]: value,
          }
        : materialAvulso,
    );
    setMateriaisAvulsos(novoMateriaisAvulsos);
  }

  function handleSelecionarItem(itemDomsge: iAutoCompleteItem | null) {
    setItemDomsgeSelecionado(itemDomsge);
  }

  let materiaisFiltrados: any[] = [];

  if (!materiaisAvulsos?.length) {
    materiaisFiltrados = [];
  } else if (campoBusca) {
    materiaisFiltrados = materiaisAvulsos.filter(
      item => item.material.descricaoFabrSge === campoBusca.toUpperCase(),
    );
  } else {
    materiaisFiltrados = materiaisAvulsos;
  }

  function handleToggleTodosAvulsos() {
    setPropostaMaterialSelecionado(prev => {
      const todosIds = materiaisFiltrados.map(m => m.id);

      const todosMarcados = todosIds.every(id =>
        prev.some(p => p.id === id && p.isAvulso),
      );

      if (todosMarcados) {
        return prev.filter(p => !p.isAvulso || !todosIds.includes(p.id));
      }

      const novos = materiaisFiltrados
        .filter(m => !prev.some(p => p.id === m.id && p.isAvulso))
        .map(m => ({
          id: m.id,
          desconto: m.desconto ?? 0,
          isAvulso: true,
          isFaturamentoDireto,
          codigo: m.material.codigoSap ?? m.material.diteCodigo,
          fabricanteDesc: m.material.descricaoFabrSge,
        }));

      return [...prev, ...novos];
    });
  }

  function Materiais(): JSX.Element {
    if (!materiaisAvulsos.length) {
      return (
        <tr>
          <Td className="text-center" colSpan={5}>
            Nenhum registro encontrado
          </Td>
        </tr>
      );
    }

    return (
      <>
        {materiaisFiltrados.map(materialAvulso => {
          const { id } = materialAvulso;
          return (
            <MaterialItem
              key={id}
              propostaMaterial={materialAvulso}
              canEdit={acessoIncluiMaterialAvulso && permiteModificacao}
              canDelete={acessoIncluiMaterialAvulso && permiteModificacao}
              handleChangeValue={handleChangeValue}
              disabled={updating}
              onClickUpdate={() => updateMaterialAvulso(materialAvulso)}
              onClickDelete={() => deleteMaterialAvulso(id)}
              acessoLimitadoListaMateriais={acessoLimitadoListaMateriais}
              isAvulso
              onAddFinanciamentoDireto={() =>
                handleOnAddFinanciamentoDiretoAvulsos(materialAvulso)
              }
              isFaturamentoDireto={isFaturamentoDireto}
              setPropostaMaterialSelecionado={setPropostaMaterialSelecionado}
              propostaMaterialSelecionado={propostaMaterialSelecionado}
              mostrarSelecao={mostrarSelecao}
            />
          );
        })}
      </>
    );
  }

  return (
    <>
      <CardHeader>
        <Row>
          <Col sm="10">
            <h4 className="mb--1">Materiais avulsos da proposta</h4>
            <small className="text-muted"> </small>
          </Col>
          {acessoIncluiMaterialAvulso && (
            <Col className="align-items-right" sm="2">
              <Button
                size="sm"
                disabled={updating}
                className="btn-icon btn-2"
                style={{ backgroundColor: '#1a8c5b' }}
                color="success"
                type="button"
                onClick={() => {
                  // eslint-disable-next-line no-restricted-globals
                  history.push({
                    pathname: `/admin/configurador-itens-lote`,
                    state: {
                      propostaId: propostaVersao.id,
                      emprCodigo: codEmpresa,
                    },
                  });
                }}
              >
                <span className="btn-inner--text">Cadastro em lote</span>
              </Button>
            </Col>
          )}
        </Row>
      </CardHeader>

      {permiteModificacao && acessoIncluiMaterialAvulso && (
        <Card>
          <AutocompleteItem
            hideTitle
            handleSelecionarItem={handleSelecionarItem}
            maxWidth="60vw"
            noAutoFocus
            emprCodigo={codEmpresa}
          >
            <Input
              type="number"
              min={1}
              className="ml-2"
              value={quantidadeNovoItem}
              onChange={event =>
                setQuantidadeNovoItem(parseInt(event.target.value, 10))
              }
            />

            <Input
              className="ml-2"
              type="select"
              value={atividadeNovoItem !== 0 ? atividadeNovoItem : ''}
              onChange={text => setAtividadeNovoItem(Number(text.target.value))}
            >
              <option value="">Atividade</option>
              {atividades
                .filter(item => item.produtoId === produtoProposta)
                ?.map(ativ => (
                  <option
                    key={ativ.id}
                    value={ativ.id}
                    title={ativ.codSGE ? `Ref. DomSGE: ${ativ.codSGE}` : ''}
                  >
                    {traduzirProdutoAtividade(ativ)}
                  </option>
                ))}
            </Input>
            <Button
              disabled={updating}
              className="btn-icon btn-2"
              color="primary"
              type="button"
              onClick={addMaterialAvulso}
            >
              <FaPlusCircle />
            </Button>
          </AutocompleteItem>
        </Card>
      )}

      <Card>
        <CardBody className="p-1">
          {loading ? (
            <Row>
              <Col className="text-center mb-4 mt-4">
                <CircularProgress />
              </Col>
            </Row>
          ) : (
            <Table bordered responsive>
              <thead>
                <tr>
                  <Th>&nbsp;</Th>
                  <Th>Ativ</Th>
                  <Th>Item</Th>
                  <Th className="text-center">Quantidade</Th>
                  <Th className="text-center">Desconto(%)</Th>
                  {!acessoLimitadoListaMateriais && (
                    <>
                      <Th className="text-right">Valor unitário</Th>
                      <Th className="text-right">Valor total</Th>
                    </>
                  )}{' '}
                  {mostrarSelecao && (
                    <Th
                      className="text-center w-auto"
                      style={{ width: '80px' }}
                    >
                      <Checkbox
                        color="primary"
                        className="mr-1 float-center"
                        checked={
                          materiaisAvulsos.length > 0 &&
                          materiaisAvulsos.every(m =>
                            propostaMaterialSelecionado.some(
                              p => p.id === m.id && p.isAvulso,
                            ),
                          )
                        }
                        indeterminate={
                          materiaisAvulsos.some(m =>
                            propostaMaterialSelecionado.some(
                              p => p.id === m.id && p.isAvulso,
                            ),
                          ) &&
                          !materiaisAvulsos.every(m =>
                            propostaMaterialSelecionado.some(
                              p => p.id === m.id && p.isAvulso,
                            ),
                          )
                        }
                        onChange={handleToggleTodosAvulsos}
                      />
                    </Th>
                  )}
                </tr>
              </thead>
              <tbody>{Materiais()}</tbody>
              <tfoot hidden={campoBusca !== ''}>
                <MaterialTotalItem
                  texto="Total materiais avulsos"
                  valor={formatCurrency(valorTotalAvulsos)}
                  elementType="h2"
                  acessoLimitadoListaMateriais={acessoLimitadoListaMateriais}
                  isAvulso
                />
              </tfoot>
            </Table>
          )}
        </CardBody>
      </Card>
    </>
  );
}
